<template>
    <div class="label-page layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar 
            v-bind:className="'title-bar-label'"
            v-bind:titleData="titleData"
            v-bind:backFunc="checkStatus"
            v-bind:cancelFunc="checkStatus"
            v-bind:saveFunc="clickSave"
            v-bind:createFunc="clickSearch"
            v-bind:createGray="this.selectedLabelData.length == 0">
        </title-bar>

        <!-- 2. 输入标签及已选择的标签 -->
        <div class="label-choosed" @click="clickLabelChoosed">
            <!-- 输入框有两种状态 -->
            <div class="label-choosed-content-box">
                <input type="text" ref="labelinput" class="label-choosed-input" maxlength="12" v-model="inputValue" @focus="focusLabel" @blur="blurLabel" @input="inputLabel" @keyup="keyupLabel($event)" >
                <span v-if="selectedLabelData.length == 0 && !inputFocused" class="label-choosed-note">{{labelNote}}</span>
                <div v-else class="label-choosed-content">
                    <span class="label-item-box" v-for="sLabel in selectedLabelData" v-bind:key="'selected' + sLabel.id">
                        <span class="label-item" v-bind:class="{'delete': sLabel.canDelete}">{{sLabel.f_title}}</span>
                    </span>
                    <span class="label-choosed-cursor-box">
                        <span v-if="inputValue != ''" class="label-choosed-note label-choosed-note-left">{{inputValue}}</span>
                        <span v-if="inputFocused" class="label-choosed-cursor" v-bind:class="{'label-choosed-cursor-left':inputValue == ''}"></span>
                        <span v-if="inputValue == ''" class="label-choosed-note label-choosed-note-right">输入标签</span>
                    </span>
                </div>
            </div>

            <!-- 下拉列表 -->
            <div v-if="filterLabelListData.length > 0" class="label-choosed-list">
                <div v-for="fLabel in filterLabelListData" v-bind:key="'filter' + fLabel.id" class="label-choosed-item" @click="clickMyCommonLabelItem(fLabel)">{{fLabel.f_title}}</div>
            </div>
        </div>

        <!-- 3. 自定义标签 -->
        <div class="label-user-defined">
            <div class="label-main-title">
                <span class="label-title">自定义标签</span>
                <span v-if="showEditLabelButton && myLabelData.length > 0" class="label-edit-title" @click="editUserDefined">编辑自定义</span>
            </div>
            <div v-if="myLabelData.length > 0" class="label-list">
                <span v-for="label in myLabelData" v-bind:key="label.id" class="label-item" v-bind:class="{'cur': label.choosed}" @click="clickMyCommonLabelItem(label)">{{label.f_title}}</span>
            </div>
            <div v-else class="label-user-defined-no-data">自定义：暂无</div>
        </div>

        <!-- 4. 常用标签 -->
        <div class="label-in-common-use">
            <div class="label-main-title" @click="toggleCommonUse">
                <span class="label-title">常用标签</span><span class="label-title-note">标签越细，可搜索对比研究的八字越多</span>
                <span class="label-edit-title label-edit-title-icon">
                    <i class="iconfont" v-bind:class="{'icon-xiangshang': showCommonUseList, 'icon-xiangxia': !showCommonUseList}"></i>
                </span>
            </div>
            <div v-show="showCommonUseList">
                <div v-for="(labelList, keys) in commonLabelData" v-bind:key="'list' + keys" class="label-common-list">
                    <div class="label-common-title">{{keys}}：</div>
                    <div class="label-list">
                        <span v-for="label in labelList" v-bind:key="label.id" class="label-item" v-bind:class="{'cur': label.choosed}" @click="clickMyCommonLabelItem(label)">{{label.f_title}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 5. 命盘情况备注 -->
        <div v-if="fromPage != 'search'" class="label-remark" v-bind:class="{'label-remark-fixed': showCommonUseList}">
            <div class="label-main-title" @click="toggleRemark">
                <span class="label-title">命盘情况备注</span>
                <span class="label-edit-title" @click.stop="clickEditRemark">编辑</span>
            </div>
            <div v-if='remarkValue != "" && showRemark && !textareaFocused' class="label-remark-content">
                <p class="label-remark-paragraph">{{remarkValue}}</p>
            </div>
            <div v-if="showRemark && textareaFocused" class="label-remark-content">
                <textarea ref="remarktext" v-model="remarkValue" @input="inputTextArea" @focus="focusTextArea" @blur="blurTextArea" class="label-remark-textarea" name="" id="" cols="30" rows="5" placeholder="在此可输入零散的命主情况，如果要配合流年大运分析，建议在批盘或论盘中记录"></textarea>
            </div>
        </div>
    </div>
</template>
<script>
import { DOM } from '../../modules/dom'
import { SCHEME, UTILS } from '../../modules/utils'
import { LABEL_DATA_MANAGER } from '../../modules/data'
import TitleBar from '../../components/TitleBar.vue'
export default {
    name: 'Label',
    components: {TitleBar},
    computed: {
        chooseLabelFromPage() {
            return this.$store.state.collate.chooseLabelFromPage;
        },
        selectedLabelChanged() {
            return this.$store.state.label.selectedLabelChanged;
        },
        myLabelData() {
            return this.$store.state.label.myLabelData;
        },
        commonLabelData() {
            return this.$store.state.label.commonLabelData;
        },
        selectedLabelData() {
            return this.$store.state.label.selectedLabelData;
        },
        filterLabelListData() {
            return this.$store.state.label.filterLabelListData;
        }
    },
    data() {
        return {
            fromPage: '',
            titleData: {
                'titleText': '标签及备注', 
                'showCancel': true,
                'saveButton': true
            },
            labelNote: '在下方选择已有标签，或输入自定义标签',
            inputFocused: false,
            inputValue: '',
            tempValue: '',
            showChoosedList: false,
            newLabelIdNum: 10000,
            remarkValue: '',
            showEditLabelButton: false,
            showCommonUseList: true,
            showRemark: false,
            textareaFocused: false,
            canDeleteWord: false
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = window.innerWidth + 'px';
            this.$el.style.height = window.innerHeight + 'px';
        },
        initData() {
            var me = this,
                curPath = this.$router.history.current.path,
                fromPage = UTILS.getQueryString('from');
            if((curPath.indexOf('search') != -1 && curPath.indexOf('detail') == -1) || (curPath.indexOf('embedded') != -1 && fromPage && fromPage == 'searchlabel')) {
                this.fromPage = 'search';
                this.titleData.titleText = '标签搜索';
                this.titleData.showCancel = false;
                this.titleData.saveButton = false;
                this.titleData.titleCreate = '搜索';
                this.labelNote = '在下方选择已有标签，或输入关键词搜索';
            }
            if(curPath.indexOf('collate') != -1 || (curPath.indexOf('detail') != -1 && curPath.indexOf('share') == -1)) {
                this.showEditLabelButton = true;
            }
            if(curPath.indexOf('embedded') == -1) {
                this.$store.dispatch('label/initLabelList');
                this.$store.dispatch('label/updateComfirmedSelectedLabel');
                // 暂时这么处理一下吧
                var remarkStringData = this.$store.state.label.remarkStringData;
                this.remarkValue = remarkStringData != '' ? remarkStringData : this.remarkValue;
            }else {
                // 暂时这么处理一下吧
                setTimeout(() => {
                    var remarkStringData = me.$store.state.label.remarkStringData;
                    me.remarkValue = remarkStringData != '' ? remarkStringData : this.remarkValue;
                }, 1000);
                if(fromPage == 'selectlabel' || fromPage == 'updatelabel') {
                    this.showEditLabelButton = true;
                }
            }
            // 暂时这么处理一下吧
            var remarkStringData = this.$store.state.label.remarkStringData;
            this.remarkValue = remarkStringData != '' ? remarkStringData : this.remarkValue;
            this.$store.state.label.selectedLabelChanged = false;
        },
        clickSearch() {
            var me = this,
                curPath = this.$router.history.current.path;
            if(this.selectedLabelData.length > 0) {
                var labelResult = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(this.selectedLabelData),
                    labelString = LABEL_DATA_MANAGER.getSearchedLabelStringByList(this.selectedLabelData);
                if(curPath.indexOf('embedded') == -1) {
                    this.$store.dispatch('label/saveSearchedLabelData');
                    this.$store.dispatch('search/confirmSearchLabel', {
                        labelId: labelResult.id,
                        cb: function(resultList) {
                            console.log('标签搜索结果:::::::', resultList)
                            if(resultList.length == 0) {
                                me.$toast('不存在相关标签的八字');
                            }else {
                                me.$store.state.search.searchResultFromPage = 'label';
                                me.$router.replace('/search/result');
                                DOM.setHiddenByClassName('search-layout-content');
                            }
                        }
                    });
                }else {
                    SCHEME.saveSearchLabel(labelResult.id, labelResult.totalStr, labelString)
                }
            }
        },
        checkStatus() {
            var me = this;
            if(this.fromPage == 'search') {
                this.goBack();
                this.$store.dispatch('label/resetSelectedData')
                this.$store.state.label.selectedLabelChanged = false;
                return;
            }
            if(!this.selectedLabelChanged) {
                this.goBack();
                return;
            }
            this.$dialog.confirm({
                message: '是否要保存修改？',
                confirmButtonText: '保存',
                cancelButtonText: '不保存'
            }).then(() => {
                // 触发保存
                me.clickSave();
                me.$store.state.label.selectedLabelChanged = false;
            }).catch(() => {
                // 返回上一页
                me.goBack();
                me.$store.state.label.selectedLabelChanged = false;
                me.$store.dispatch('label/resetSelectedData')
            });
        },
        goBack() {
            // 更新数据状态
            this.$store.dispatch('label/updateComfirmedSelectedLabel');

            var curPath = this.$router.history.current.path;
            console.log('LabelManage------goBack::::::', curPath)
            // 起盘页面
            if(curPath.indexOf('/collate') != -1 && curPath.indexOf('detail') == -1) {
                if(this.chooseLabelFromPage == '') {
                    this.$router.replace('/collate');
                }else {
                    this.$router.replace(this.chooseLabelFromPage);
                }
                DOM.showPageByClassName('collate-page');
            // 编辑页面
            }else if(curPath.indexOf('/edit') != -1 || curPath.indexOf('/share') != -1 || curPath.indexOf('/detail') != -1 || curPath.indexOf('/search') != -1 || curPath.indexOf('/famouspedia') != -1) {
                curPath = curPath.replace('/label', '');
                this.$router.replace(curPath);
            }else if(curPath.indexOf('/embedded') != -1) {
                SCHEME.closeWebView();
            }
        },
        clickSave() {
            var me = this,
                curPath = this.$router.history.current.path;

            this.saveInputLabel();
            this.$store.state.label.remarkStringData = this.remarkValue;
            this.$store.dispatch('label/saveSelectedLabelData', {
                curPath: curPath,
                cb: function() {
                    console.log('保存成功:::::::')
                    var labelStr = me.$store.state.label.selectedLabelString,
                        labelId = me.$store.state.label.selectedLabelId,
                        remarkText = me.$store.state.label.remarkStringData;
                    console.log('.....请求保存数据', labelStr, labelId, remarkText)
                    if(curPath.indexOf('detail') != -1) {
                        me.$store.dispatch('detail/updateDetailLabelStatus', {
                            label: labelId,
                            remark: remarkText
                        })
                    }else if(curPath.indexOf('embedded') != -1) {
                        var fromPage = UTILS.getQueryString('from');
                        if(fromPage == 'selectlabel') {
                            SCHEME.saveSelectLabel(labelId, labelStr, remarkText);
                        }else if(fromPage == 'updatelabel') {
                            SCHEME.saveUpdateLabel(labelId, labelStr, remarkText);
                            // me.$store.dispatch('detail/updateDetailLabelStatus', {
                            //     label: labelId,
                            //     remark: remarkText,
                            //     cb: function() {
                            //         SCHEME.saveUpdateLabel(labelId, labelStr, remarkText);
                            //     }
                            // })
                        }
                    }
                    me.updateEditPageLabel();
                    setTimeout(() => {
                        me.goBack();
                    }, 20);
                }
            })
        },
        clickLabelChoosed() {
            var inputDom = this.$refs.labelinput;
            inputDom.focus();
            inputDom.addEventListener('compositionstart', this.updateInput);
            inputDom.addEventListener('compositionupdate', this.updateInput);
            this.canDeleteWord = true;
        },
        updateInput($event) {
            this.canDeleteWord = $event.data == '' ? true : false;
            if($event.data != '') {
                this.$store.dispatch('label/resetSelectedLabelDataDeleteStatus');
            }
        },
        saveInputLabel() {
            this.canDeleteWord = true;
            this.inputValue = this.inputValue.trim();
            if(this.inputValue == '') { return; }
            var duplicated = LABEL_DATA_MANAGER.checkUnduplicatedSelectedLabelData(this.selectedLabelData, this.inputValue);
            if(duplicated) {
                this.inputValue = '';
            }else {
                // todo here:检查是否已经有这个标签了,有的话
                var totalList = this.$store.state.label.totalLabelListData;
                var labelData = LABEL_DATA_MANAGER.getLabelInTotalLabelListByText(totalList, this.inputValue);
                console.log('getLabelInTotalLabelListByText-------', labelData)
                if(labelData.id) {
                    this.clickMyCommonLabelItem(labelData);
                }else {
                    this.getNewLabelItem();
                }
            }
        },
        getNewLabelItem() {
            this.$store.dispatch('label/addSelectedLabelData', {
                id: 'new'+this.newLabelIdNum,
                title: this.inputValue
            });
            this.newLabelIdNum++;
            this.inputValue = '';
        },
        focusLabel() {
            // this.inputValue = '';
            this.inputFocused = true;
        },
        blurLabel() {
            var me = this;
            setTimeout(() => {
                if(me.filterLabelListData.length == 0) {
                    me.saveInputLabel();
                }
                me.inputFocused = false;
                window.scrollTo(0, 0);
            }, 20);
        },
        inputLabel() {
            if(this.inputValue != '') {
                this.$store.dispatch('label/resetSelectedLabelDataDeleteStatus');
            }
            this.$store.dispatch('label/getFilterLabelList', this.inputValue);
        },
        keyupLabel($el) {
            var me = this;
            // pc上回车键保存
            if($el.keyCode == 13 && this.inputValue != '') {
                this.saveInputLabel();
            }
            // 删除键:删除已经选择的label项
            if($el.keyCode == 8) {
                if(!this.canDeleteWord) { 
                    this.canDeleteWord = true;
                    return;
                }
                if(this.tempValue == '' && this.inputValue == '') {
                    this.$store.dispatch('label/deleteSelectedLabelData')
                }
            }
            this.tempValue = this.inputValue;
        },
        editUserDefined() {
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('embedded') == -1) {
                curPath = curPath.replace('label', 'labelmanage');
                this.$router.replace(curPath);
            }else {
                var curUrl = window.location.href;
                    curUrl = curUrl.replace('label', 'labelmanage');
                window.location = curUrl;
            }
        },
        clickMyCommonLabelItem(data) {
            this.inputValue = '';
            this.$store.state.label.filterLabelListData.splice(0);
            // 更新状态数据
            this.$store.dispatch('label/resetSelectedLabelDataDeleteStatus');
            this.$store.dispatch('label/updateLabelDataChoosedStatus', data);
            this.$store.dispatch('label/updateSelectedLabelData', data);
            this.updateEditPageLabel();

            var me = this,
                inputDom = this.$refs.labelinput;
            setTimeout(() => {
                inputDom.blur();
                me.inputFocused = false;
            }, 20);
        },
        toggleCommonUse() {
            this.showCommonUseList = !this.showCommonUseList;
            this.showRemark = !this.showCommonUseList;
            var me = this;
            if(this.showRemark && this.remarkValue == '') {
                this.textareaFocused = true;
                var me = this;
                setTimeout(() => {
                    me.$refs.remarktext.focus();
                }, 20);
            }
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        toggleRemark() {
            this.showRemark = true;
            this.textareaFocused = false;
            this.showCommonUseList = false;
            if(this.remarkValue == '') {
                this.textareaFocused = true;
                var me = this;
                setTimeout(() => {
                    me.$refs.remarktext.focus();
                }, 20);
            }
        },
        clickEditRemark() {
            this.showRemark = true;
            this.textareaFocused = true;
            this.showCommonUseList = false;
            var me = this;
            setTimeout(() => {
                me.$refs.remarktext.focus();
            }, 20);
        },
        inputTextArea() {
            if(this.remarkValue != this.$store.state.label.remarkStringData) {
                this.$store.state.label.selectedLabelChanged = true;
                this.updateEditPageLabel();
            }
        },
        focusTextArea() {
            this.showRemark = true;
            this.textareaFocused = true;
            this.showCommonUseList = false;
        },
        blurTextArea() {
            this.textareaFocused = false;
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        updateEditPageLabel() {
            // 处理编辑页面的逻辑
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('edit') != -1) {
                this.$store.state.edit.editedStatus = true;
            }
        }
    }
}
</script>